import { mergeObjectTypes } from '../cacheHelpers';

const BookingStageCheck = {
  merge: mergeObjectTypes
};

export default BookingStageCheck;
